import { Box, Typography } from '@mui/material';

interface IProps {
  x: number;
  y: number;
  label: string;
  metricLabel: string;
  value: string;
}

/** Same dark rounded-box look as the legacy GeoMapModal, generalized to any metric. */
const MapHoverTooltip = ({ x, y, label, metricLabel, value }: IProps) => (
  <Box
    sx={{
      position: 'absolute',
      left: x,
      top: y,
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      bgcolor: '#131316',
      color: '#fff',
      borderRadius: 1,
      px: 1.5,
      py: 1,
      zIndex: 10,
      whiteSpace: 'nowrap',
    }}
  >
    <Typography variant='caption' sx={{ display: 'block', color: '#B6B4BA' }}>
      {label}
    </Typography>
    <Typography variant='caption' sx={{ display: 'block' }}>
      {metricLabel}: {value}
    </Typography>
  </Box>
);

export default MapHoverTooltip;
